import { Component, ElementRef, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../../application/services/auth.service';

// Dropdown del usuario en el header. Muestra el nombre y las opciones de perfil.
// Se cierra automaticamente cuando el usuario hace click fuera del componente.
@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [CommonModule],
})
export class UserDropdownComponent {
  isOpen = false;
  isLoggingOut = false;

  private authService = inject(AuthService);

  constructor(private elementRef: ElementRef) {}

  get currentUser() { return this.authService.currentUser(); }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  logout(): void {
    this.isLoggingOut = true;
    this.authService.logout();
  }

  // Cierra el dropdown si el click ocurrio fuera del elemento del componente
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }
}
